import _classCallCheck from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _assertThisInitialized from "/builds/mkp/mkp-crm/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { IconButton } from '@material-ui/core';
import CopyIcon from '@material-ui/icons/FileCopyOutlined';
import CloseIcon from '@material-ui/icons/Close';
import { SnackbarProvider, withSnackbar } from 'notistack';

var ClipBoardCopy =
/*#__PURE__*/
function (_Component) {
  _inherits(ClipBoardCopy, _Component);

  function ClipBoardCopy() {
    var _getPrototypeOf2;

    var _this;

    _classCallCheck(this, ClipBoardCopy);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(ClipBoardCopy)).call.apply(_getPrototypeOf2, [this].concat(args)));

    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "copy", function () {
      var _this$props = _this.props,
          text = _this$props.text,
          callback = _this$props.callback,
          enqueueSnackbar = _this$props.enqueueSnackbar;
      navigator.clipboard.writeText(text).then(function () {
        // Promise resolved successfully.
        enqueueSnackbar('تم النسخ', {
          variant: 'success'
        });
        if (callback) callback();
      }, function () {
        // Promise rejected.
        console.error("Unable to write to clipboard. :-(");
      });
    });

    return _this;
  }

  _createClass(ClipBoardCopy, [{
    key: "render",
    value: function render() {
      return React.createElement(IconButton, {
        color: "primary",
        onClick: this.copy
      }, React.createElement(CopyIcon, {
        fontSize: "small"
      }));
    }
  }]);

  return ClipBoardCopy;
}(Component);

ClipBoardCopy.propTypes = {
  text: PropTypes.string.isRequired
};
ClipBoardCopy = withSnackbar(ClipBoardCopy);

function ClipBoardCopyProvider(props) {
  return React.createElement(SnackbarProvider, {
    maxSnack: 3,
    action: [React.createElement(IconButton, null, React.createElement(CloseIcon, {
      fontSize: "small",
      color: "disabled"
    }))]
  }, React.createElement(ClipBoardCopy, props));
}

export default ClipBoardCopyProvider;